var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConnect = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 74,
  height: 62,
  viewBox: "0 0 74 62",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.9076 60.7589C18.4833 60.1411 20.0704 57.5523 19.4526 54.9767C18.8349 52.4011 16.2461 50.8139 13.6704 51.4317C11.0948 52.0495 9.50765 54.6383 10.1254 57.2139C10.7432 59.7895 13.332 61.3767 15.9076 60.7589Z",
  stroke: "#BDCAD1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M59.8085 10.5184C62.3841 9.90064 63.9713 7.31186 63.3535 4.73622C62.7357 2.16059 60.1469 0.573434 57.5713 1.19122C54.9957 1.809 53.4085 4.39778 54.0263 6.97342C54.6441 9.54905 57.2329 11.1362 59.8085 10.5184Z",
  stroke: "#BDCAD1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.4329 39.4545C43.451 38.2509 46.5432 33.2073 45.3396 28.1892C44.136 23.1712 39.0923 20.079 34.0743 21.2826C29.0562 22.4862 25.964 27.5298 27.1676 32.5479C28.3712 37.5659 33.4149 40.6582 38.4329 39.4545Z",
  fill: "#845EC2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M41.4952 12.87C33.7767 10.4696 25.0829 13.5753 20.7015 20.8336C16.3008 28.0115 17.4767 37.1681 23.0367 42.9773L17.1691 52.5478M32.633 48.2434C39.9593 49.7174 47.73 46.6631 51.8862 39.884C56.0424 33.1049 55.2395 24.7942 50.6026 18.9337L56.1034 9.96129",
  stroke: "#BDCAD1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgConnect);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/connect.7f71b0f70e13a062e7b08c46ac24a22c.svg";